export default "__VITE_ASSET__BjAtef4e__"